<!-- 
MARCO DC 09/05/2022

è un UnidataEditorBasic leggermente più complesso, 
riesce a gestire più valori tramite array

N.B.

Gli array devono essere all'ineati non il primo elemento dell'array actions deve essere
coerente col primo elemento dell'array stores

-->
<template>
  <div class="unidata-editor" style="padding: 3px">
    <div class="row mr-0">
      <div v-if="title != ''" class="col-8">
        <label v-tooltip="uniToolTipTranslation(title, 'en-US')" class="label-picker">
          {{ uniTranslation(title) }}</label
        >
      </div>
      <div v-for="(val, index) in values" :key="index" :class="'col-2 unidata-item-container'">
        <VueAutonumeric
          v-model="values[index]"
          class="form-control auto-numeric"
          :options="{
            allowDecimalPadding: false,
            digitGroupSeparator: '',
            decimalCharacter: ',',
            decimalCharacterAlternative: '.',
            decimalPlaces: decimals,
            currencySymbol: '\u00a0€',
            currencySymbolPlacement: 's',
            roundingMethod: 'D' /* 'U' */,
            symbolWhenUnfocused: '',
            selectOnFocus: 'false',
            currencySymbol: '',
            negativePositiveSignPlacement: 'p',
            minimumValue: min
          }"
          @blur="change(index)"
        ></VueAutonumeric>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueAutonumeric from "../shared/VueAutonumeric";

export default {
  components: {
    VueAutonumeric
  },
  props: {
    title: {
      type: String,
      required: true
    },
    stores: {
      type: Array,
      required: true
    },
    getters: {
      type: Array,
      required: true
    },
    actions: {
      type: Array,
      required: true
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    decimals: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      values: [],
      unsubscribe: [],
      mapped_subscribes: []
    };
  },
  computed: {},
  watch: {},
  mounted: function() {
    var that = this;
    that.getters.forEach((el, index) => {
      that.values.push(that.$store.getters[`${that.stores[index]}/${el}`]);

      that.mapped_subscribes.push(`${that.stores[index]}/${that.actions[index]}`);
    });

    that.unsubscribe = that.$store.subscribe(function(mutation) {
      var i = that.mapped_subscribes.indexOf(mutation.type);
      if (i > -1) {
        that.values = [];
        that.getters.forEach((el, index) => {
          that.values[index] = that.$store.getters[`${that.stores[index]}/${that.getters[index]}`];
        });
      }
    });
  },
  methods: {
    change(index) {
      var that = this;
      that.$store.commit(`${that.stores[index]}/${that.actions[index]}`, that.values[index]);
    }
  }
  //===============================================================================================
};
</script>
<style lang="scss">
$input-height: 30px;

.unidata-editor {
  background-color: transparent;
  margin: 0 0 0px 0px !important;
  //padding: 10px 0;
  width: 100%;
  outline: none;

  .unidata-item-container {
    border: none;
    height: $input-height !important;
    padding: 0 0px;

    .select {
      border: none;
    }

    .form-control {
      padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.auto-numeric {
        padding: 0 5px;
        text-align: center;
      }

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}
.label-unidato {
  margin-top: 9px;
  margin-bottom: 0px;
}

.loading {
  opacity: 0.3;
}
</style>
